<template>
  <div class="flex h-full w-full">
    <div class="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/50 to-30% to-transparent"></div>
    <Container className="relative flex flex-col gap-y-10">
      <div class="flex flex-col text-white text-4xl sm:text-5xl lg:text-7xl pt-32 px-6 leading-[1.2] text-center">
        <div>{{ addressPart1 }}</div>
        <div>{{ addressPart2 }}</div>
      </div>
      <div class="flex justify-center">
        <PlayButton 
          @click.native="runTopMedia()" 
          v-if="!getTopFirstPhoto" 
          class="md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2"
        />
      </div>
      <div class="hidden md:flex text-2xl sm:text-4xl space-y-2 text-white h-full flex-col items-end justify-end pb-8 sm:pb-16">
        <div v-if="price" class="text-3xl sm:text-5xl mb-3 sm:mb-5">
          <span 
            :class="{
              'text-primary-color': !getPrimaryColor,
              [`text-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >$</span>{{ price.replace('$', '') }}
        </div>
        <div v-if="bedrooms">
          <span
            :class="{
              'text-primary-color': !getPrimaryColor,
              [`text-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >{{ bedrooms }}</span> 
          Beds
        </div>
        <div v-if="bathrooms">
          <span
            :class="{
              'text-primary-color': !getPrimaryColor,
              [`text-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >{{ bathrooms }}</span> 
          Baths
        </div>
        <div v-if="squareFootage">
          <span
            :class="{
              'text-primary-color': !getPrimaryColor,
              [`text-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >{{ squareFootage }}</span> 
          Sqft
        </div>
      </div> 
    </Container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import addressMixin from '@/shared/mixins/address';
  import PlayButton from '../PlayButton';
  import Container from '../Container';

  export default {
    name: 'TopContent',
    mixins: [
      addressMixin
    ],
    components: {
      PlayButton,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getDetails', 'getTopVideo', 'getTop360Tour', 'getTopSlideshow', 'getTopFirstPhoto', 'getPrimaryColor']),
      price () {
        return this.getDetails.price.value;
      },
      squareFootage () {
        const value = this.getDetails.totalSquareFootage.value;
        return value && value.split(' sqft').shift();
      },
      bedrooms () {
        return this.getDetails.bedrooms.value;
      },
      bathrooms () {
        return this.getDetails.bathrooms.value;
      },
    },
    methods: {
      ...mapActions('ui', ['runTopMedia']),
      scrollDown() {
        this.$emit('onClickLink', 'header');
      }
    }
  };
</script>
